import React from 'react';
import { Bath, HelpCircle } from 'lucide-react';

const BathroomLocationStep = ({ value, onChange }) => {
  const gridDirections = [
    ['NW', 'N', 'NE'],
    ['W', 'Center', 'E'],
    ['SW', 'S', 'SE']
  ];

  const toggleCell = (cellId) => {
    const current = Array.isArray(value) ? value : [];
    if (current.includes(cellId)) {
      onChange(current.filter(id => id !== cellId));
    } else {
      onChange([...current, cellId]);
    }
  };

  const specialOptions = [
    { id: 'scattered', label: 'Scattered across the home' },
    { id: 'unsure', label: 'Not sure / No idea' }
  ];

  const handleSpecialOption = (optionId) => {
    onChange([optionId]);
  };

  const isSpecialSelected = Array.isArray(value) && value.length === 1 && specialOptions.some(opt => opt.id === value[0]);

  return (
    <div>
      <h3 className="text-2xl font-bold text-[#232323] mb-2">Where are most of your toilets/bathrooms?</h3>
      <p className="text-[#353535] mb-6">You can select multiple areas. Tap all that apply.</p>
      
      {/* Direction grid */}
      <div className="flex justify-center mb-6">
        <div className="grid grid-cols-3 gap-3 p-6 bg-white rounded-xl border-2 border-gray-200">
          {gridDirections.map((row, rowIdx) => (
            row.map((dir, colIdx) => {
              const cellId = dir.toLowerCase().replace(' ', '-');
              const isSelected = Array.isArray(value) && value.includes(cellId);
              
              return (
                <button
                  key={`${rowIdx}-${colIdx}`}
                  onClick={() => toggleCell(cellId)}
                  disabled={dir === 'Center' || isSpecialSelected}
                  className={`w-24 h-24 rounded-lg border-2 font-bold text-sm transition-all hover:scale-105 ${
                    isSelected
                      ? 'bg-[#232323] text-white border-[#232323]'
                      : 'bg-white text-[#232323] border-gray-300 hover:border-[#232323]'
                  } ${
                    dir === 'Center' || isSpecialSelected ? 'opacity-50 cursor-not-allowed' : ''
                  }`}
                >
                  <div className="flex flex-col items-center justify-center">
                    <Bath className="w-6 h-6 mb-1" />
                    <span>{dir}</span>
                  </div>
                </button>
              );
            })
          ))}
        </div>
      </div>

      <p className="text-center text-sm text-[#353535] mb-4">Or choose one of these:</p>

      {/* Special options */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {specialOptions.map((option) => {
          const isSelected = Array.isArray(value) && value.includes(option.id);
          
          return (
            <button
              key={option.id}
              onClick={() => handleSpecialOption(option.id)}
              className={`p-4 border-2 rounded-xl text-left transition-all hover:shadow-md ${
                isSelected
                  ? 'border-[#232323] bg-[var(--accent-saffron)]'
                  : 'border-gray-200 hover:border-[#999999]'
              }`}
            >
              <div className="flex items-center gap-3">
                <HelpCircle className="w-5 h-5 text-[#232323]" />
                <span className="font-semibold text-[#232323]">{option.label}</span>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BathroomLocationStep;